
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from 'reactstrap';
import 'react-day-picker/lib/style.css';
import { faDatabase, faExclamationTriangle, faWindowRestore } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BackupService from '../Services/BackupService/backupService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import { Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import RolesType from '../utils/roles';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: blue;
`;

export default class Backup extends Component {
    constructor(props) {
        super();
        this.state = {
            Filter: {
                FilterCompanyCode: null
            },
            SelectCompanyCode: "",
            modal: { warning: false },
            Button: <a className="btn btn-success">OK</a>,
            loading: true,
            isAutenticated: true
        };
        this.companyCodeValue = this.companyCodeValue.bind(this);
        this.toggleWarning = this.toggleWarning.bind(this);
    }
    componentDidMount() {

    }
    companyCodeValue(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    toggleWarning() {
        this.setState({
            modal: { warning: !this.state.modal.warning }
        });
    }
    setOperation(a, id, operations) {
        if (operations === "SAVE") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.SaveBackup(e) }} disabled >OK</a>,
                loading: false
            });
            this.toggleWarning();
        } else if (operations === "SAVE_RESTORE") {
            this.setState({
                Button: <a className="btn btn-warning" onClick={(e) => { this.SaveRestoreBackup(e) }} disabled >OK</a>,
                loading: false
            });
            this.toggleWarning();
        }
    }
    SaveRestoreBackup(e) {
        e.preventDefault();
        var email = sessionStorage.getItem('email');
        var restore = true;
        var result = BackupService.SaveBackup(this.state.Filter.FilterCompanyCode, email, restore);
        var that = this;

        that.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.SaveRestoreBackup(e) }} disabled >OK</a>
        });
        result.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: { warning: false },
                    loading: false
                });
                toast.success("Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: { warning: false },
                    loading: false
                });
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: { warning: false },
                    loading: false
                });
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch(function (error) {
            that.setState({
                modal: { warning: false }
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    SaveBackup(e) {
        e.preventDefault();
        var email = sessionStorage.getItem('email');
        var result = BackupService.SaveBackup(this.state.Filter.FilterCompanyCode, email);
        var that = this;
        that.setState({
            loading: true,
            Button: <a className="btn btn-warning disabled" onClick={(e) => { this.SaveBackup(e) }} disabled >OK</a>
        });
        result.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: { warning: false },
                    loading: false
                });
                toast.success("Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {
                that.setState({
                    modal: { warning: false },
                    loading: false
                });
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "AuditError") {
                that.setState({
                    modal: { warning: false },
                    loading: false
                });
                toast.error("Not Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch(function (error) {
            that.setState({
                modal: { warning: false }
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    renderBackupRow() {
        let dataResult = RolesType;

        var temp = Object.keys(dataResult);
        if (sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1]) {
            return (<div>
                <div className="row" >
                    <div className="col-12" >
                        <Card >
                            <CardBody >
                                <div className="row" id="timelogs_filter">
                                    <div className="col-lg-2 col-md-2 col-sm-2">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Company Code</label>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                            <input className="form-control" name="companycode" id="companycode" type="text" onChange={this.companyCodeValue} value={this.state.Filter.FilterCompanyCode ? this.state.Filter.FilterCompanyCode : ""} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="form-group">
                                            <a className="btn btn-success" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.setOperation(e, "", 'SAVE')}><FontAwesomeIcon icon={faDatabase} />&nbsp;&nbsp;Generate Backup</a>
                                            <a className="btn btn-success" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.setOperation(e, "", 'SAVE_RESTORE')}><FontAwesomeIcon icon={faWindowRestore} />&nbsp;&nbsp;SAVE AND RESTORE Backup</a>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div><br />
            </div>);
        } else {
            return (<Redirect to={'/login'} />)
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        return (
            <div>
                <MainLayout />
                <div className="container" ><ToastContainer hideProgressBar />
                    {
                        this.renderBackupRow()
                    }
                </div>
                <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}
                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-warning"}
                >
                    <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                    </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                        <p><FontAwesomeIcon color="#FFBB33" icon={faExclamationTriangle} size="3x" /></p>
                        <p>Are you sure?</p>
                    </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#FF8800'}
                            loading={this.state.loading}
                        />
                        {this.state.Button}
                        {
                            this.state.loading
                                ? <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning} disabled>CLOSE</a>
                                : <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning}>CLOSE</a>
                        }
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/backup/backup.jsx